import React from 'react';
import { Button } from '@/components/ui/button';

type DemoBannerProps = {
  message?: string;
  onDismiss?: () => void;
};

const DemoBanner: React.FC<DemoBannerProps> = ({ message = 'DEMO MODE — actions are simulated.', onDismiss }) => {
  return (
    <div className="fixed inset-x-0 top-14 flex justify-center z-50">
      <div className="max-w-3xl mx-4 bg-yellow-500/95 text-black px-4 py-2 rounded shadow flex items-center justify-between gap-4">
        <div className="text-sm font-medium">{message}</div>
        <div>
          <Button size="sm" variant="ghost" onClick={onDismiss} className="bg-black/5">
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
